"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSource = void 0;
const core_1 = require("flow-connect/core");
class FileSource extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.OUT, name: "file", dataType: "file" }]);
    }
    created(options) {
        const { width = 130, name = "File Source", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, FileSource.DefaultState), state);
        this.setupUI();
        this.setupListeners();
    }
    process() {
        this.setOutputs(0, this.state.file);
    }
    setupUI() {
        this.fileInput = this.createUI("core/source", { propName: "file", input: true, output: true, height: 20 });
        this.ui.append(this.fileInput);
    }
    setupListeners() {
        this.watch("file", () => this.process());
    }
}
exports.FileSource = FileSource;
FileSource.DefaultState = { file: null };
